import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav';
import DesktopSidebar from './DesktopSidebar';
import FloatingProfile from './FloatingProfile';

const AppLayout = () => {
  return (
    <div className="flex min-h-screen bg-background relative overflow-x-hidden">
      <DesktopSidebar />
      <FloatingProfile />
      <main className="flex-1 w-full min-w-0 pb-20 md:pb-0">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
};

export default AppLayout;